<section class="wrapper-content my-3 sm:my-5">
    <form [formGroup]="form" class="pl-0 col-12">
        <div class="flex flex-column gap-2 ">
            <div class="inline-flex justify-content-between align-items-center">
                <h3 class="font-23 font-normal font-roboto-condensed title-blue uppercase mb-3">
                    {{ 'components.app-authentication-manager.profile-form.title' | translate }}
                </h3>
                <button *ngIf="modoEdicion" pButton type="button" icon="pi pi-times" iconPos="right"
                        [label]="'form.button.cancelar' | translate" (click)="cancel()"
                        class="bg-button-outline-blue-light border-outline-blue-light
                                            font-normal text-blue-general w-12rem"></button>
            </div>
            <!--#region Formulario Usuario-->
            <main class="grid formgrid p-fluid">
                @if (!modoEdicion) {
                    <div class="field col-12  ">
                        <div class="grid ">
                            <div class="col-3 sm:col-4 lg:col-3 xl:col-2">
                                @if (loading) {
                                    <ng-container
                                            *ngTemplateOutlet="skeleton; context: { shape:'circle', size:'4rem' }"/>
                                } @else {
                                    <p-avatar size="xlarge" shape="circle" [label]="firstLetterName"/>
                                }
                            </div>
                            <div class="col-9 sm:col-6 lg:col-6 xl:col-7">
                                <label class="label-form-sidebar" for="nombreCompleto">
                                    {{ "components.app-authentication-manager.profile-form.nombre-completo" | translate }}
                                </label>
                                <p class="font-16 font-normal my-1" *ngIf="!loading else skeleton ">
                                    {{ infoProfile.nombreCompleto }}
                                </p>
                            </div>
                            <div class="col-12 lg:col-3 xl:col-3">
                                <div class="flex justify-content-start mt-5 lg:mt-0 md:justify-content-center">
                                    <button pButton type="button" icon="pi pi-pencil" iconPos="right"
                                            [label]="'components.app-authentication-manager.profile-form.modificar-perfil' | translate"
                                            class="bg-button-outline-blue-light border-outline-blue-light
                                            font-normal text-blue-general w-12rem"
                                            (click)="editar()"></button>
                                </div>
                            </div>
                        </div>
                        <p-divider class="col-12"/>
                    </div>

                    <div class="field col-12 md:col-6 xl:col-4  app-container-input-blue">
                        <label class="label-form-sidebar" for="tipoIdentificacionId">
                            {{ "components.app-authentication-manager.register-form.tipoIdentificacionId" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading ">{{ infoProfile.tipoIdentificacionDescripcion }}</p>
                        <p-skeleton *ngIf="loading" width="6rem"/>

                    </div>

                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="identificacion">
                            {{ "components.app-authentication-manager.register-form.identificacion" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton">{{ infoProfile.identificacion }}</p>
                    </div>

                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="telefono">
                            {{ "components.app-authentication-manager.register-form.telefono" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton">{{ infoProfile.telefono }}</p>
                    </div>
                    <div class="field col-12 md:col-6  xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="correoElectronico">
                            {{ "components.app-authentication-manager.register-form.correoElectronico" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1" *ngIf="!loading else skeleton ">{{ infoProfile.correo }}</p>
                    </div>
                    <div class="field col-12 xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="direccion">
                            {{ "components.app-authentication-manager.register-form.direccion" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.direccion }}</p>
                    </div>

                    <div class="field col-12 md:col-6  xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="paisExpedicionId">
                            {{ "components.app-authentication-manager.register-form.paisExpedicionId" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.paisDescripcion }}</p>
                    </div>
                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue" *ngIf="isOtroPaisExpedicion">
                        <label class="label-form-sidebar" for="otroPaisExpedicion">
                            {{ "components.app-authentication-manager.register-form.otroPaisExpedicion" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.otroPais }}</p>
                    </div>

                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue" *ngIf="!isOtroPaisExpedicion">
                        <label class="label-form-sidebar" for="departamentoExpedicionId">
                            {{ "components.app-authentication-manager.register-form.departamentoExpedicionId" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.departamentoDescripcion }}</p>
                    </div>
                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue"
                         *ngIf="isOtroPaisExpedicion || isOtroDepartamentoExpedicion">
                        <label class="label-form-sidebar" for="otroDepartamentoExpedicion">
                            {{ "components.app-authentication-manager.register-form.otroDepartamentoExpedicion" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.otroDepartamento }}</p>
                    </div>

                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue" *ngIf="isMunicipioExpedicionIdVisible">
                        <label class="label-form-sidebar" for="municipioExpedicionId">
                            {{ "components.app-authentication-manager.register-form.municipioExpedicionId" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.municipioDescripcion }}</p>

                    </div>
                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue"
                         *ngIf="isOtroPaisExpedicion || isOtroDepartamentoExpedicion || isOtroMunicipioExpedicion">
                        <label class="label-form-sidebar" for="otroMunicipioExpedicion">
                            {{ "components.app-authentication-manager.register-form.otroMunicipioExpedicion" | translate }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.otroMunicipio }}</p>

                    </div>

                    <div class="field col-12 md:col-6 xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="fechaExpedicion">{{
                                "components.app-authentication-manager.register-form.fechaExpedicion" | translate
                            }}
                        </label>
                        <p class="font-16 font-normal my-1"
                           *ngIf="!loading else skeleton ">{{ infoProfile.fechaExpedicion | date : 'dd/MM/YYYY' }}</p>
                    </div>


                } @else {
                    <div class="field col-12 md:col-6 lg:col-5 xl:col-4 app-container-input-blue">
                        <label class="label-form-sidebar" for="tipoIdentificacionId">{{
                                "components.app-authentication-manager.register-form.tipoIdentificacionId" | translate
                            }}
                            <span style="color: red">*</span>
                        </label>
                        <p-dropdown [options]="tipoIdentificaciones" *ngIf="modoEdicion"
                                    formControlName="tipoIdentificacionId" appendTo="body" class="border-blue"
                                    [placeholder]="'components.app-authentication-manager.register-form.tipoIdentificacionId' | translate"
                                    optionLabel="abreviatura" optionValue="id"
                                    [style]="{'width':'100%'}">
                        </p-dropdown>
                        <ng-container
                                *ngIf="form.get('tipoIdentificacionId')?.invalid && form.get('tipoIdentificacionId')?.dirty">
                            <app-form-group-error-message [control]="form.get('tipoIdentificacionId')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 lg:col-7 xl:col-8 app-container-input-blue">
                        <label class="label-form-sidebar" for="identificacion">{{
                                "components.app-authentication-manager.register-form.identificacion" | translate
                            }}<span
                                    style="color: red">*</span></label>
                        <p-inputNumber formControlName="identificacion" id="identificacion"
                                       inputStyleClass="w-full" styleClass="w-full"
                                       class="w-full" [useGrouping]="false"></p-inputNumber>
                        <ng-container
                                *ngIf="form.get('identificacion')?.invalid && form.get('identificacion')?.touched">
                            <app-form-group-error-message [control]="form.get('identificacion')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 lg:col-6 xl:col-3 app-container-input-blue">
                        <label class="label-form-sidebar" for="primerNombre">{{
                                "components.app-authentication-manager.register-form.primerNombre"  | translate
                            }}
                            <span style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="primerNombre" class="border-blue w-full"
                               id="primerNombre" type="text"/>
                        <ng-container *ngIf="form.get('primerNombre')?.invalid && form.get('primerNombre')?.touched">
                            <app-form-group-error-message [control]="form.get('primerNombre')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 lg:col-6 xl:col-3 app-container-input-blue">
                        <label class="label-form-sidebar" for="segundoNombre">{{
                                "components.app-authentication-manager.register-form.segundoNombre" | translate
                            }}</label>
                        <input pInputText formControlName="segundoNombre" id="segundoNombre"
                               type="text" class="border-blue w-full"/>
                        <ng-container *ngIf="form.get('segundoNombre')?.invalid && form.get('segundoNombre')?.touched">
                            <app-form-group-error-message [control]="form.get('segundoNombre')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 lg:col-6 xl:col-3 app-container-input-blue">
                        <label class="label-form-sidebar" for="primerApellido">{{
                                "components.app-authentication-manager.register-form.primerApellido" | translate
                            }}
                            <span style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="primerApellido" id="primerApellido"
                               type="text" class="border-blue w-full"/>
                        <ng-container
                                *ngIf="form.get('primerApellido')?.invalid && form.get('primerApellido')?.touched">
                            <app-form-group-error-message [control]="form.get('primerApellido')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 lg:col-6 xl:col-3 app-container-input-blue">
                        <label class="label-form-sidebar" for="segundoApellido">
                            {{ "components.app-authentication-manager.register-form.segundoApellido" | translate }}
                        </label>
                        <input pInputText formControlName="segundoApellido" id="segundoApellido"
                               type="text" class="border-blue w-full"/>
                        <ng-container
                                *ngIf="form.get('segundoApellido')?.invalid && form.get('segundoApellido')?.touched">
                            <app-form-group-error-message [control]="form.get('segundoApellido')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue">
                        <label class="label-form-sidebar" for="telefono">{{
                                "components.app-authentication-manager.register-form.telefono" |
                                    translate
                            }}
                            <span style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="telefono" id="telefono"
                               type="text" class="border-blue w-full"/>
                        <ng-container *ngIf="form.get('telefono')?.invalid && form.get('telefono')?.touched">
                            <app-form-group-error-message [control]="form.get('telefono')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue">
                        <label class="label-form-sidebar" for="correoElectronico">
                            {{ "components.app-authentication-manager.register-form.correoElectronico" | translate }}
                            <span *ngIf="!usuarioTieneFirmaActiva" style="color: red">*</span>
                            <i *ngIf="usuarioTieneFirmaActiva" class="pi pi-info-circle" [style.color]="'#3282F3'"
                                [pTooltip]="'Para editar el correo electronico, debe deshabilitar la firma electronica'" 
                                [escape]="false" tooltipPosition="top"></i>
                        </label>
                        <input pInputText formControlName="correoElectronico"
                               id="correoElectronico" type="text" class="border-blue w-full"/>
                        <ng-container
                                *ngIf="form.get('correoElectronico')?.invalid && form.get('correoElectronico')?.touched">
                            <app-form-group-error-message [control]="form.get('correoElectronico')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 app-container-input-blue">
                        <label class="label-form-sidebar" for="direccion">{{
                                "components.app-authentication-manager.register-form.direccion"
                                    | translate
                            }}
                            <span style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="direccion" id="direccion"
                               type="text" class="border-blue w-full"/>
                        <ng-container *ngIf="form.get('direccion')?.invalid && form.get('direccion')?.touched">
                            <app-form-group-error-message [control]="form.get('direccion')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue">
                        <label class="label-form-sidebar" for="paisExpedicionId">
                            {{ "components.app-authentication-manager.register-form.paisExpedicionId" | translate }}
                            <span style="color: red">*</span>
                        </label>
                        <p-dropdown [options]="paises" formControlName="paisExpedicionId"
                                    appendTo="body" (onChange)="onPaisChange($event.value)"
                                    [placeholder]="'components.app-authentication-manager.register-form.paisExpedicionId' | translate"
                                    optionLabel="descripcion" [style]="{'width':'100%'}"
                                    [filter]="true">
                        </p-dropdown>
                        <ng-container
                                *ngIf="form.get('paisExpedicionId')?.invalid && form.get('paisExpedicionId')?.dirty">
                            <app-form-group-error-message [control]="form.get('paisExpedicionId')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue" *ngIf="isOtroPaisExpedicion">
                        <label class="label-form-sidebar" for="otroPaisExpedicion">
                            {{ "components.app-authentication-manager.register-form.otroPaisExpedicion" | translate }}
                            <span
                                    style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="otroPaisExpedicion"
                               id="otroPaisExpedicion" type="text" class="border-blue w-full"/>
                        <ng-container
                                *ngIf="form.get('otroPaisExpedicion')?.invalid && form.get('otroPaisExpedicion')?.touched">
                            <app-form-group-error-message [control]="form.get('otroPaisExpedicion')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue" *ngIf="!isOtroPaisExpedicion">
                        <label class="label-form-sidebar" for="departamentoExpedicionId">
                            {{ "components.app-authentication-manager.register-form.departamentoExpedicionId" | translate }}
                            <span style="color: red">*</span>
                        </label>
                        <p-dropdown [options]="departamentos" formControlName="departamentoExpedicionId" appendTo="body"
                                    (onChange)="onDepartamentoChange($event.value)"
                                    [placeholder]="'components.app-authentication-manager.register-form.departamentoExpedicionId' | translate"
                                    optionLabel="descripcion" [style]="{'width':'100%'}"
                                    [filter]="true">
                        </p-dropdown>
                        <ng-container
                                *ngIf="form.get('departamentoExpedicionId')?.invalid && form.get('departamentoExpedicionId')?.dirty">
                            <app-form-group-error-message [control]="form.get('departamentoExpedicionId')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue"
                         *ngIf="isOtroPaisExpedicion || isOtroDepartamentoExpedicion">
                        <label class="label-form-sidebar" for="otroDepartamentoExpedicion">
                            {{ "components.app-authentication-manager.register-form.otroDepartamentoExpedicion" | translate }}
                            <span style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="otroDepartamentoExpedicion"
                               id="otroDepartamentoExpedicion" type="text" class="w-full border-blue"/>
                        <ng-container
                                *ngIf="form.get('otroDepartamentoExpedicion')?.invalid && form.get('otroDepartamentoExpedicion')?.touched">
                            <app-form-group-error-message [control]="form.get('otroDepartamentoExpedicion')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue" *ngIf="isMunicipioExpedicionIdVisible">
                        <label class="label-form-sidebar" for="municipioExpedicionId">
                            {{ "components.app-authentication-manager.register-form.municipioExpedicionId" | translate }}
                            <span style="color: red">*</span>
                        </label>
                        <p-dropdown [options]="municipios" formControlName="municipioExpedicionId" appendTo="body"
                                    [placeholder]="'components.app-authentication-manager.register-form.municipioExpedicionId' | translate"
                                    optionLabel="descripcion" [style]="{'width':'100%'}"
                                    [filter]="true">
                        </p-dropdown>
                        <ng-container
                                *ngIf="form.get('municipioExpedicionId')?.invalid && form.get('municipioExpedicionId')?.dirty">
                            <app-form-group-error-message [control]="form.get('municipioExpedicionId')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue"
                         *ngIf="isOtroPaisExpedicion || isOtroDepartamentoExpedicion || isOtroMunicipioExpedicion">
                        <label class="label-form-sidebar" for="otroMunicipioExpedicion">
                            {{ "components.app-authentication-manager.register-form.otroMunicipioExpedicion" | translate }}
                            <span
                                    style="color: red">*</span>
                        </label>
                        <input pInputText formControlName="otroMunicipioExpedicion" id="otroMunicipioExpedicion"
                               type="text" class="border-blue w-full"/>
                        <ng-container
                                *ngIf="form.get('otroMunicipioExpedicion')?.invalid && form.get('otroMunicipioExpedicion')?.touched">
                            <app-form-group-error-message [control]="form.get('otroMunicipioExpedicion')"/>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 app-container-input-blue">
                        <label class="label-form-sidebar" for="fechaExpedicion">{{
                                "components.app-authentication-manager.register-form.fechaExpedicion" | translate
                            }}
                            <span style="color: red">*</span>
                        </label>
                        <p-calendar id="fechaExpedicion"
                                    formControlName="fechaExpedicion"></p-calendar>
                        <ng-container
                                *ngIf="form.get('fechaExpedicion')?.invalid && form.get('fechaExpedicion')?.touched">
                            <app-form-group-error-message [control]="form.get('fechaExpedicion')"/>
                        </ng-container>
                    </div>
                    <div class="col-12 mt-4">
                        <div class="flex justify-content-center gap-3">
                            <button pButton type="submit" icon="pi pi-save" iconPos="right"
                                    (click)="onSubmit()"
                                    [label]="'form.button.actualizar' | translate"
                                    class="tax-app-button w-10rem font-normal  " ></button>
                        </div>
                    </div>
                }
                <p-divider class="col-12 my-3"/>
                <div class="col-12">
                    <h3 class="font-23 mb-3 font-normal font-roboto-condensed title-blue uppercase">
                        {{ 'components.app-authentication-manager.profile-form.empresa' | translate }}
                    </h3>
                    <custom-table [config]="propsTable"/>
                </div>
            </main>
            <!--#endRegion-->
        </div>
    </form>

</section>
<ng-template #skeleton let-shape="shape" let-size="size" let-width="width">
    <p-skeleton [shape]="shape" [size]="size" [width]="width"/>
</ng-template>

<p-dialog [(visible)]="openModal"  [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="false"
          [header]="titleModal" (onHide)="onHideModal()"
          [maximizable]="false" [breakpoints]="{'640px': '100vw'}" [style]="{width: '50vw'}" appendTo="body">
    <div class="my-4">
        <form class="grid" [formGroup]="empresaCreate" (ngSubmit)="onEmpresaCreateSubmit()">
            <div class="field col-12 lg:col-6">
                <label class="blue-bold-text" for="nombre">
                    {{_translations.razonSocial}}
                    <span style="color: red">*</span>
                </label>
                <input pInputText formControlName="nombre" id="nombre" type="text" style="width: 100%" />
                <ng-container *ngIf="empresaCreate.get('nombre')?.invalid && empresaCreate.get('nombre')?.touched">
                    <app-form-group-error-message [control]="empresaCreate.get('nombre')"/>
                </ng-container>
            </div>
            <div class="field col-12 lg:col-6">
                <label class="blue-bold-text" for="nit">
                    {{_translations.nit}}
                    <span style="color: red">*</span>
                </label>
                <input pInputText formControlName="nit" id="nit" type="text" style="width: 100%" />
                <ng-container *ngIf="empresaCreate.get('nit')?.invalid && empresaCreate.get('nit')?.touched">
                    <app-form-group-error-message [control]="empresaCreate.get('nit')"/>
                </ng-container>
            </div>
            <div class="field col-12">
                <label class="blue-bold-text" for="direccion">
                    {{_translations.direccion}}
                    <span style="color: red">*</span>
                </label>
                <input pInputText formControlName="direccion" id="direccion" type="text" style="width: 100%" />
                <ng-container *ngIf="empresaCreate.get('direccion')?.invalid && empresaCreate.get('direccion')?.touched">
                    <app-form-group-error-message [control]="empresaCreate.get('direccion')"></app-form-group-error-message>
                </ng-container>
            </div>
            <div class="field col-12 lg:col-6">
                <label class="blue-bold-text" for="telefono">
                    {{_translations.telefono}}
                    <span style="color: red">*</span>
                </label>
                <input pInputText formControlName="telefono" id="telefono" type="text" style="width: 100%" />
                <ng-container *ngIf="empresaCreate.get('telefono')?.invalid && empresaCreate.get('telefono')?.touched">
                    <app-form-group-error-message [control]="empresaCreate.get('telefono')"></app-form-group-error-message>
                </ng-container>
            </div>
            <div class="field col-12 lg:col-6">
                <label class="blue-bold-text" for="correo">
                    {{_translations.correo}}
                    <span style="color: red">*</span>
                </label>
                <input pInputText formControlName="correo" id="correo" type="text" style="width: 100%" />
                <ng-container *ngIf="empresaCreate.get('correo')?.invalid && empresaCreate.get('correo')?.touched">
                    <app-form-group-error-message [control]="empresaCreate.get('correo')"></app-form-group-error-message>
                </ng-container>
            </div>
            <div class="col-12">
                <div class="blue-bold-text">
                    {{_translations.documento}}:
                </div>
                <div class="flex flex-wrap gap-1">
                    <div class="flex flex-column">
                        <div class="flex">
                            <p-fileUpload #fileUpload mode="basic" accept="application/pdf" [maxFileSize]="uploadFileSize"
                                          [chooseLabel]="_translations.agregarDocumento" [customUpload]="true" [auto]="true" class=""
                                          (uploadHandler)="uploadHandler($event, fileUpload)" chooseIcon="pi pi-upload"></p-fileUpload>
                            <button pButton icon="pi pi-trash" class="p-button-cancel-fileupload cancel" (click)="removeFile()"
                                    [disabled]="!archivo"></button>
                        </div>

                        <ng-container *ngIf="requieredFile">
                            <small class="p-error block">{{_translations.campoRequerido}}</small>
                        </ng-container>
                        <div *ngIf="archivo">
                            <p>{{_translations.archivo}} "{{archivo.name}}" {{_translations.wasUploaded}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-4">
                <div class="flex justify-content-center gap-3">
                    <button pButton type="submit" [label]="_translations.btnActualizar"
                            class="tax-app-button" style="width: 15rem;"></button>
                </div>
            </div>

        </form>
    </div>

</p-dialog>
